/**
 * Option sources for Step 2 "Informácie o licencii".
 * Backend doména and Frontend type reused from existing app; POS and relations are fixed.
 */

export const BACKEND_DOMAIN_OPTIONS = [
  { value: "https://staging.gastrokiosk.online", label: "Staging - https://staging.gastrokiosk.online" },
  { value: "https://be.gastrokiosk.online", label: "Production - https://be.gastrokiosk.online" },
];

/** Production backend domain value (for default selection in Step 2). */
export const BACKEND_DOMAIN_PRODUCTION = BACKEND_DOMAIN_OPTIONS[1].value;

export const POS_INTEGRACIA_OPTIONS = [
  { value: "none", label: "Žiadna" },
  { value: "ikelp", label: "iKelp" },
  { value: "dotykacka", label: "Dotykačka" },
  { value: "oberon", label: "Oberon" },
  { value: "storyous", label: "Storyous" },
  { value: "agnis", label: "Agnis" },
];

export const RELATIONS_TYP_ZAKAZNIKA_OPTIONS = [
  { value: "standalone", label: "Samostatný" },
  { value: "parent", label: "Parent" },
  { value: "child", label: "Child" },
];
